import { render, staticRenderFns } from "./RoomAdminItem.vue?vue&type=template&id=3412c5ca&"
import script from "./RoomAdminItem.vue?vue&type=script&lang=js&"
export * from "./RoomAdminItem.vue?vue&type=script&lang=js&"
import style0 from "./RoomAdminItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports